import { Col } from '@/components/grid/grid-component';
import { CaptionText, Heading2Text, SubheaderText } from '@/utils/global-fonts';
import { BsImage } from 'react-icons/bs';
import styled from 'styled-components';

const ProductFilterGroupItem = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
  cursor: pointer;
  border: 1px solid
    ${({ selected, theme }) =>
      selected ? theme.COLOR_PRIMARY : theme.COLOR_GREY2};
  border-radius: 4px;
  background-color: ${({ theme }) => theme.COLOR_WHITE};
  transition: all 0.2s ease-in-out;
  @media (hover: hover) {
    &:hover {
      border: 1px solid ${({ theme }) => theme.COLOR_GREY1};
      .prodCatTitle {
        color: ${({ theme }) => theme.COLOR_BLACK} !important;
      }
    }
  }
  justify-content: space-between;
`;

const ImageHolder = styled.div`
  width: 100%;
  height: auto;
  padding: 0 24px;
  padding-top: 16px;
`;

const ProductFilterGroupItemTitle = styled(SubheaderText)`
  display: flex;
  gap: 5px;
`;
const TitleItems = styled.span``;

const ProductFilterGroupItemImage = styled.img`
  width: 100%;
  max-height: 150px;
  object-fit: contain;
  margin-bottom: 1.5rem;
  pointer-events: none;
  user-select: none;
  -webkit-user-drag: none;
  -khtml-user-drag: none;
  -moz-user-drag: none;
  -o-user-drag: none;
  user-drag: none;
  border-radius: 4px;
  overflow: hidden;
`;

const NoThumbnail = styled(BsImage)`
  color: ${({ theme }) => theme.COLOR_GREY4};
  height: auto;
  width: 100%;
  border-radius: 4px;
  overflow: hidden;
`;

const ProductFilterGroupItemDescription = styled(CaptionText)`
  font-size: 12px;
  margin: 0;
  padding: 0 20px;
  color: ${({ theme }) => theme.COLOR_GREY_TEXT};
`;

const DragIndicator = styled.div`
  position: absolute;
  top: 10px;
  left: 10px;
  cursor: pointer;
`;

const ReorderProductsContainer = styled.div`
  width: 100%;
  height: 100%;
  padding-bottom: 82px;
  .draggable-container {
    margin-bottom: 0;
  }
`;

const NoProductCategory = styled(Col)`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

const NoProductCategoryImg = styled.img`
  width: 64px;
  height: 64px;
`;

const NoProductCategoryHeaderText = styled(Heading2Text)`
  margin: 0;
  padding: 0 20px;
  width: 100%;
  display: block;
  text-align: center;
  margin-top: 24px;
`;

const NoProductCategoryText = styled(CaptionText)`
  margin: 0;
  padding: 0 20px;
  width: 50%;
  font-size: 14px;
  display: block;
  text-align: center;
  font-weight: 400;
  margin-top: 24px;
  color: ${({ theme }) => theme.COLOR_GREY_TEXT};
`;

export default {
  DragIndicator,
  NoProductCategoryHeaderText,
  NoProductCategoryImg,
  NoProductCategoryText,
  ProductFilterGroupItem,
  ProductFilterGroupItemTitle,
  TitleItems,
  NoThumbnail,
  ProductFilterGroupItemImage,
  ProductFilterGroupItemDescription,
  ReorderProductsContainer,
  NoProductCategory,
  ImageHolder,
};
